<template>
  <div id="app">
    <SimplePage hide-header>
      <div class="message">
        <p class="ja summary">{{ $t(`${currentName}/summary`) }}</p>
        <p class="en summary">{{ $t(`${currentName}/summary`, 'en') }}</p>
        <p class="ja description">{{ $t(`${currentName}/description`) }}</p>
        <p class="en">{{ $t(`${currentName}/description`, 'en') }}</p>
      </div>
    </SimplePage>
  </div>
</template>

<script>
import SimplePage from '@/components/templates/SimplePage'

export default {
  name: 'App',
  components: {
    SimplePage,
  },
  computed: {
    currentName() {
      return this.$root.page
    },
  },
}
</script>

<style lang="postcss" scoped>
.message {
  background: #fff;
  flex: 1 1 auto;
  height: 100%;
  margin: -32px -16px;
  padding: 32px 16px;
  white-space: pre-wrap;
  word-wrap: break-word;

  @media screen and (min-width: 768px) {
    flex-grow: 0;
    height: auto;
    margin: 32px 0;
    padding: 80px 16px;
    text-align: center;
  }
}

.ja {
  color: var(--very-dark-gray-1);

  &.summary {
    font-size: 22px;
    margin-bottom: 24px;

    @media screen and (min-width: 768px) {
      font-size: 24px;
    }
  }

  &.description {
    margin-bottom: 24px;
  }
}

.en {
  font-size: 12px;

  &.summary {
    margin-bottom: 56px;
  }
}
</style>
